module.exports = __webpack_public_path__ + "img/bagging_grouping.6d3390de.svg";